import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => {
  return {
    contentTitle: {
      textAlign: 'center',
      marginBottom: '70px',
      font: `700 19px/25px "Montserrat"`,
      color: theme.custom.colors.primary,
    },
    iconCloseIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '20px',
      cursor: 'pointer'
    },
    listType: {
      display: 'flex',
      width: '70%',
      justifyContent: 'center',
      margin: '0 auto',
    },
    typeTitle: {
      font: theme.custom.font.headingMontserrat3,
      marginBottom: 15
    },
    icon: {
      height: "32px",
      width: "32px"
    },
    itemType: {
      boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
      borderRadius: 10,
      textAlign: 'center',
      padding: '24px 9px',
      cursor: 'pointer',
      '&:focus': {
        border: `1px solid ${theme.custom.colors.purple}`,
      },
      '&:not(:last-child)': {
        marginRight: 64
      },
      '& img': {
        marginBottom: 27
      },
      '&:hover': {
        border: `1px solid ${theme.custom.colors.purp}`
      }
    },
    itemType2: {
      boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
      borderRadius: 10,
      textAlign: 'center',
      padding: '24px 40px',
      cursor: 'pointer',
      '&:focus': {
        border: `1px solid ${theme.custom.colors.purple}`,
      },
      '&:not(:last-child)': {
        marginRight: 64
      },
      '& img': {
        marginBottom: 27
      },
      '&:hover': {
        border: `1px solid ${theme.custom.colors.purp}`
      }
    },
    selected: {
      border: `1px solid ${theme.custom.colors.purp}`
    },
    typeDes: {
      font: 'normal normal 400 14px/18px Montserrat',
      marginBottom: 13,
      color: theme.custom.colors.midBlack,
    },
    bodyModalList: {
      padding: '24px',
      height: '81%',
      overflowY: 'scroll'
    },
    btnAddRecipeBody: {
      '& button': {
        height: 32,
        background: theme.custom.colors.purple,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.title,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '& img': {
          marginLeft: 8,
        },
        '&:hover': {
          background: theme.custom.colors.purple,
        },
      },
    },
    footerModal: {
      height: '19%',
      padding: '24px 119px 55px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
    },
    buttonBack: {
      '& button': {
        height: 32,
        background: theme.custom.colors.borderGrey,
        fontWeight: 'bold',
        fontSize: theme.custom.fontSize.size16,
        fontFamily: 'Montserrat',
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        color: '#333333',
        marginRight: 24,
        '&:hover': {
          background: theme.custom.colors.borderGrey,
        },
      },
    },
  };
});

export default useStyles;
